import { combineReducers } from "redux";
import FormActions from "./reducers/form";
import AnswersActions from "./reducers/answers";
import NotesActions from "./reducers/notes";
import TestsReducer from "./reducers/tests";

import FormSections from "./reducers/form-builder/sections";
import FormGroups from "./reducers/form-builder/groups";
import FormQuestions from "./reducers/form-builder/questions";
import FormPossibleAnswers from "./reducers/form-builder/possibleAnswers";

let allReducers = combineReducers({
    form: FormActions,
    answers: AnswersActions,
    notes: NotesActions,
    tests: TestsReducer,
    formSections: FormSections,
    formGroups: FormGroups,
    formQuestions: FormQuestions,
    formPossibleAnswers: FormPossibleAnswers
});

export default allReducers;


// WEBPACK FOOTER //
// ./src/redux/index.js